import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import { } from "../../core/feature/store";
import * as api_info from "../../core/service/api_info";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import card from "../../assets/images/icon_card/card.svg";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { Dialog, Listbox, Switch, Transition } from "@headlessui/react";
import settingIcon from "../../assets/images/icon_card/setting.svg";
import settingBlackIcon from "../../assets/images/icon_card/setting-black.svg";
import tkiWhite from "../../assets/images/icon_card/tki-white.svg";
import syncHistory from "../../assets/images/icon_card/sync.svg";
import helpIcon from "../../assets/images/icon_card/help.svg";
import TabsMobile from "../__template/TabsMobileComponent";
import { Stats, StatsInvoice, StatsMessage } from "../common/home/Stats";
import "swiper/css";
import "swiper/css/pagination";
import CustomApp from "../../core/models/customApp";
import * as api_card from "../../core/service/api_card";

import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { setLoading } from "../../core/feature/config/configSlice";

// import required modules
import {
  Autoplay,
  EffectCoverflow,
  Keyboard,
  Navigation,
  Pagination,
} from "swiper";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import Company from "../../core/models/company";
import _ from "lodash";
import { BackButton } from "../common/BackButton";
import { isDarkColor } from "../../config/DarkColorChecker";

const CardWeb = () => {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const [pages, setPage] = useState(0);
  let companyStorage = JSON.parse(String(localStorage.getItem("company")));
  const [lastPage, setLastPage] = useState(0);
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [position, setPosition] = useState(0);
  const [cards, setCards] = useState<any>([]);
  const [selectedCard, setSelectedCard] = useState<any>({});
  const [tempDaily, setTempDaily] = useState("");
  const [daily, setDaily] = useState(0);
  const [tempLimitMax, setTempLimitMax] = useState("");
  const [limitMax, setLimitMax] = useState(0);
  const [tempCardBalance, setTempCardBalance] = useState("");
  const [cardBalance, setCardBalance] = useState(0);
  const [isUnlimited, setIsUnlimited] = useState(false);
  const [isUnlimited2, setIsUnlimited2] = useState(false);
  const [currentUnlimited, setCurrentUnlimited] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  let [isOpen, setIsOpen] = useState(false);
  let [noData, setNoData] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [selectedTags, setSelectedTags] = useState<any>([]);
  const { t } = useTranslation();
  const cardData = JSON.parse(String(localStorage.getItem("card")));
  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      // console.log(companyStorage.cardSetting.limitChange, "ini kompany")
      getUserData();
      getAllCard();
      getUnlimited();
    }
  }, []);
  useEffect(() => {
    console.log("tes", location.pathname.split("/")[2]);
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getAllCard() {
    api_card.getCards().then((res: any) => {
      console.log(res.data.length);
      if (res.data.length > 0) {
        if (!localStorage.getItem("card")) {
          localStorage.setItem("card", JSON.stringify(res.data));
        }
        let temp = cards.concat(res.data);
        setCards(temp);

        setSelectedCard(temp[0]);
        setLimitMax(temp[0].limitMax);
        setDaily(temp[0].limitDaily);
        setCardBalance(temp[0].cardBalance);

        setTempLimitMax(getCurrency(temp[0].limitMax));
        setTempDaily(getCurrency(temp[0].limitDaily));
        setTempCardBalance(getCurrency(temp[0].cardBalance));
      }
    });
  }

  function getUserData() {
    api_card
      .getUser()
      .then((res) => {
        let tempUser = {
          active: res.data.accounts[0].active,
          address: res.data.address,
          banks: res.data.banks,
          callerId: "",
          callerName: "",
          callerTitle: "",
          dateOfBirth: res.data.dateOfBirth,
          email: res.data.email,
          gender: res.data.gender,
          maritalStatus: res.data.maritalStatus,
          name: res.data.name,
          nik: res.data.name,
          note: res.data.note,
          phone: res.data.phone,
          photoUrl: res.data.photoUrl,
          placeOfBirth: res.data.placeOfBirth,
          religion: res.data.religon,
          roles: res.data.accounts[0].roles,
          socmedAccounts: res.data.sosmedAccounts,
          sourceOfFund: res.data.accounts[0].sourceOfFund,
          tags: [],
          transactionUnlimited: res.data.accounts[0].transactionUnlimited,
        };
        console.log(res.data);
        let temp = res.data.accounts[0].transactionUnlimited;
        setCurrentUnlimited(temp);
        setIsUnlimited(temp);
        setIsUnlimited2(temp);
        setCurrentUser(tempUser);
      })
      .catch((er) => {
        navigate("/login", { replace: true });
      });
  }

  function saveData() {
    let unlimitedChanged = isUnlimited != currentUnlimited
    let limitChanged = selectedCard.cardBalance != cardBalance || selectedCard.limitMax != limitMax || selectedCard.limitDaily != daily

    if (unlimitedChanged) {
      let temp = currentUser;
      temp.transactionUnlimited = isUnlimited;
      api_card
        .saveUnlimited(temp)
        .then((res: any) => { 
          closeModal()
          getUserData()
        })
        .catch((e) => { closeModal() });
    }

    if (limitChanged) {
      let temp = selectedCard;
      temp.cardBalance = cardBalance;
      temp.limitMax = limitMax;
      temp.limitDaily = daily;
      api_card
        .saveCard(temp.id, temp)
        .then((res: any) => { })
        .catch((e) => { });
    }
    // var studentCard = _.find(cardData, { id: selectedCard.id });
    // var studentCardIndex = _.findIndex(cardData, { id: selectedCard.id });
    // studentCard.dateSync = moment().format("LLL");
    if (unlimitedChanged || limitChanged) {
      var studentCard = _.find(cardData, { id: selectedCard.id });
      console.log(cardData, selectedCard.id);
  
      var studentCardIndex = _.findIndex(cardData, { id: selectedCard.id });
      var dateSync = [];
      dateSync = studentCard?.dateSync || [];
      dateSync.push(moment().format("YYYY-MM-DD HH:mm"));
      studentCard.dateSync = dateSync;
  
      _.replace(cardData, cardData[studentCardIndex], studentCard);
      localStorage.setItem("card", JSON.stringify(cardData));
    }
    
    closeModal();
  }

  function getUnlimited() {
    let temp = JSON.parse(String(localStorage.getItem("user_redux")))
      .accounts[0].transactionUnlimited;
    setIsUnlimited(temp);
  }

  function goToSync(){
    navigate(`/digital-card/${cards[position].id}`)
  }

  function closeModal() {
    setIsOpen(false);
    setIsUnlimited(isUnlimited2);
  }

  function openModal() {
    setLimitMax(cards[position].limitMax);
    setDaily(cards[position].limitDaily);
    setCardBalance(cards[position].cardBalance);

    setIsOpen(true);
  }
  const [help, setHelp] = useState(false);

  function onPositionChange(currentPosition: any) {
    if (currentPosition != position) {
      setPosition(currentPosition);
      setSelectedCard(cards[currentPosition]);

      setCardBalance(cards[currentPosition].cardBalance);
      setLimitMax(cards[currentPosition].limitMax);
      setDaily(cards[currentPosition].limitDaily);
    }
    console.log(selectedCard);
  }

  function getLastSync(id: any) {
    var studentCard = _.find(cardData, { id: id });
    console.log(
      moment(studentCard?.dateSync).format("DD-MMMM-YYYY hh:mm"),
      "dfdfkdk"
    );
    if (Array.isArray(studentCard?.dateSync) && studentCard.dateSync.length > 0) {
      return studentCard.dateSync[studentCard.dateSync.length - 1];
    } else {
      return "";
    }
  }

  function numberOnly(str: any) {
    return String(str).replace(/[^0-9.]/g, "");
  }

  function getCurrency(str: any) {
    return formatCurrency(str).replace(",00", "");
  }
  return (
    <div className="bg-psp-primary mb-8 font-montserrat">
      <StatsInvoice />
      <div className="h-auto flex bg-psp-primary mt-10">
        <div className="mx-none  container h-full flex-row flex justify-between relative mb-16">
          <div className="flex flex-col rounded-2xl -top-36 relative bg-white items-center py-2 px-8  w-3/5 my-2 mx-1">
            <div className="flex py-2 px-2 w-full relative flex-col bg-white mb-8 ">
              <div className="flex mb-4">
                <BackButton />
                <div className="font-bold text-4xl">
                  {t("DIGITALCARD.title")}
                </div>
              </div>
              <Swiper
                onSlideChange={(e) => {
                  onPositionChange(e.activeIndex);
                }}
                onSwiper={(swiper) => { }}
                effect={"coverflow"}
                grabCursor={true}
                centeredSlides={false}
                pagination={true}
                loop={false}
                keyboard={{
                  enabled: true,
                }}
                centeredSlidesBounds={true}
                slidesPerView={card.length >= 2 ? 1 : 2}
                navigation={{
                  prevEl: ".swiper-button-prev",
                  nextEl: ".swiper-button-next",
                }}
                onScroll={(e) => {
                  {
                  }
                }}
                coverflowEffect={{
                  rotate: 0,
                  stretch: 50,
                  depth: 100,
                  modifier: 2.5,
                  slideShadows: false,
                }}
                modules={[EffectCoverflow, Navigation, Keyboard]}
                className="w-full h-auto mb-10 sm:mb-20 relative items-center justify-center "
              >
                {cards.map((item: any, index: any) => {
                  return (
                    <SwiperSlide
                      key={index}
                      className="flex justify-center relative  w-full h-auto items-center overflow-visible"
                    >
                      <div className="w-80 h-auto rounded-2xl relative">
                        <img src={card} className="h-full w-full absolute" />
                        <div className="relative w-full z-10 p-2.5 pt-3 text-white">
                          <div className="w-full h-[220px] text-xs font-semibold ">
                            <div className="flex h-5 pl-1 pt-2 mb-4 justify-between">
                              <img src={tkiWhite} className=" h-5 pl-1 pt-1" />
                              <div className=" text-right">
                                {item.callerName}
                              </div>
                            </div>
                            <div className="text-center">
                              <div className=" font-light">
                                {t("DIGITALCARD.balanceCard")}
                              </div>
                              <div className=" font-bold text-2xl mb-1">
                                {getCurrency(selectedCard?.cardBalance)}
                              </div>
                              <div className=" font-light">
                                NFC ID
                              </div>
                              <div className=" font-medium">
                                {/* {selectedCard?.nfcId} */}
                                {/* {JSON.stringify(item)} */}
                                {item.nfcId}
                              </div>
                            </div>
                          </div>
                          
                          {/* <div className="w-full h-8 justify-end text-end text-[1vw]">
                            
                          </div>
                          <div className="w-full h-8 ">{item.nfcId}</div> */}
                          
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <div className="w-full flex relative -top-20 flex-row justify-center">
                <div
                  className=""
                  style={{
                    borderRadius: 10,
                    height: 18,
                    width: "70%",
                    backgroundColor: "#B5B5B5",
                    filter: "blur(10px)",
                  }}
                ></div>
              </div>
            </div>
          </div>
          <div className="flex flex-col -top-36 relative py-2 w-2/5 mx-1">
            <div className="flex py-2 w-full flex-col px-4 shadow-lg rounded-2xl bg-white">
              <div className="flex flex-row">
                {help ? (
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    className="mr-1 mt-1 cursor-pointer"
                    onClick={() => setHelp(false)}
                  />
                ) : null}
                <h1 className="text-xl font-montserrat">
                  {t("DIGITALCARD.info")}
                </h1>
              </div>
              {!help ? (
                <div className="flex py-2 px-2 w-full flex-col">
                  <div className=" my-1 flex-row w-full justify-between hidden ">
                    <span className="font-montserrat font-normal w-1/2 flex relative">
                      {t("DIGITALCARD.balanceCard")}
                    </span>
                    <div className="flex flex-row justify-between w-1/2  relative">
                      <span className="font-montserrat font-normal">: </span>
                      <span className="font-montserrat font-normal">
                        {selectedCard.cardBalance && (
                          <div>{getCurrency(selectedCard.cardBalance)}</div>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="flex my-1 flex-row w-full justify-between">
                    <span className="font-montserrat font-normal  w-1/2 flex relative">
                      {t("DIGITALCARD.limitAccumulate")}
                    </span>
                    <div className="flex flex-row justify-between  w-1/2  relative">
                      <span className="font-montserrat font-normal">:</span>
                      <span className="font-montserrat font-normal">
                        {selectedCard.limitMax && (
                          <div>{getCurrency(selectedCard.limitMax)}</div>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="flex my-1 flex-row w-full justify-between">
                    <span className="font-montserrat font-normal w-1/2 flex relative">
                      {t("DIGITALCARD.dailyLimit")}
                    </span>
                    <div className="flex flex-row justify-between   w-1/2  relative">
                      <span className="font-montserrat font-normal">:</span>
                      <span className="font-montserrat font-normal">
                        {selectedCard.limitDaily && (
                          <div>{getCurrency(selectedCard.limitDaily)}</div>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="flex my-1 flex-row w-full justify-between">
                    <span className="font-montserrat font-normal w-1/2 flex relative">
                      {t("DIGITALCARD.lastSync")}
                    </span>

                    <div className="flex flex-row justify-between   w-1/2  relative">
                      <span className="font-montserrat font-normal">:</span>
                      <span className="font-montserrat font-normal text-right">
                        {getLastSync(selectedCard.id)}
                      </span>
                    </div>
                  </div>
                  <button
                    hidden={
                      companyStorage.cardSetting.limitChange ? false : true
                    }
                    onClick={openModal}
                    style={{ backgroundColor: customApp.app_accent_color }}
                    className={`px-4 mt-3 hidden font-bold items-center justify-center w-full flex-row rounded-lg gap-3 py-2 ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
                  >
                    <img src={settingIcon} alt="" className={`${isDarkColor(customApp.app_accent_color)?'':'invert'}`} />
                    {t("DIGITALCARD.setLimit")}
                  </button>
                  {/* <button
                    onClick={() => setHelp(true)}
                    className="px-4 mt-3 text-white font-bold items-center justify-center bg-yellow w-full flex flex-row rounded-lg gap-3 py-2"
                  >
                    <img src={helpIcon} alt="" />
                    {t("DIGITALCARD.help")}
                  </button> */}
                  <div className="rounded-2xl bg-psp-primary mt-7 p-2">
                    <div className="">
                      <b>{t("DIGITALCARD.balanceCard")}</b>:{" "}
                      {t("DIGITALCARD.balanceCardDesc")}
                    </div>
                    <div>
                      <b>{t("DIGITALCARD.limitAccumulate")}</b>:{" "}
                      {t("DIGITALCARD.limitAccumulateDesc")}
                    </div>
                    <div>
                      <b>{t("DIGITALCARD.dailyLimit")}</b>:{" "}
                      {t("DIGITALCARD.limitDailyDesc")}
                    </div>
                  </div>
                </div>
              ) : (
                <Transition
                  appear
                  show={help}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="flex py-2 px-2 w-full mb-8 flex-col">
                    <div className="flex my-1 flex-row w-full justify-between ">
                      <span className="font-montserrat font-normal w-1/2 flex relative">
                        {t("DIGITALCARD.balanceCard")}
                      </span>
                      <div className="flex flex-row justify-between w-1/2  relative">
                        <span className="font-montserrat font-normal">: </span>
                        <span className="font-montserrat font-normal">
                          {""}
                        </span>
                      </div>
                    </div>
                    <div className="flex my-1 flex-row w-full justify-between">
                      <span className="font-montserrat font-normal  w-1/2 flex relative">
                        {t("DIGITALCARD.limitAccumulate")}
                      </span>
                      <div className="flex flex-row justify-between  w-1/2  relative">
                        <span className="font-montserrat font-normal">:</span>
                        <span className="font-montserrat font-normal">
                          {""}
                        </span>
                      </div>
                    </div>
                    <div className="flex my-1 flex-row w-full justify-between">
                      <span className="font-montserrat font-normal w-1/2 flex relative">
                        {t("DIGITALCARD.dailyLimit")}
                      </span>
                      <div className="flex flex-row justify-between   w-1/2  relative">
                        <span className="font-montserrat font-normal">:</span>
                        <span className="font-montserrat font-normal">
                          {""}
                        </span>
                      </div>
                    </div>
                    <div className="flex my-1 flex-row w-full justify-between">
                      <span className="font-montserrat font-normal w-1/2 flex relative">
                        {t("DIGITALCARD.lastSync")}
                      </span>
                      <div className="flex flex-row justify-between   w-1/2  relative">
                        <span className="font-montserrat font-normal">:</span>
                        <span className="font-montserrat font-normal">
                          {""}
                        </span>
                      </div>
                    </div>
                    <div className="rounded-2xl bg-psp-primary mt-7 p-2">
                      <div>
                        <b>{t("DIGITALCARD.balanceCard")}</b>:{" "}
                        {t("DIGITALCARD.balanceCardDesc")}
                      </div>
                      <div>
                        <b>{t("DIGITALCARD.limitAccumulate")}</b>:{" "}
                        {t("DIGITALCARD.limitAccumulateDesc")}
                      </div>
                      <div>
                        <b>{t("DIGITALCARD.dailyLimit")}</b>:{" "}
                        {t("DIGITALCARD.limitDailyDesc")}
                      </div>
                    </div>
                  </div>
                </Transition>
              )}

              <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={closeModal}>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                  </Transition.Child>

                  <div className="fixed inset-0 overflow-y-auto font-montserrat">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                          <Dialog.Title
                            as="h3"
                            className="text-lg font-medium leading-6 text-gray-900"
                          >
                            <div className="flex flex-row">
                              <img
                                src={settingBlackIcon}
                                alt=""
                                className="text-black mr-2"
                              />
                              <div>{t("DIGITALCARD.setLimit")}</div>
                            </div>
                            <p className="text-sm text-red my-1">
                              {t("DIGITALCARD.adjustment")}
                            </p>
                          </Dialog.Title>
                          <div className="mt-2 hidden">
                            <p className="m-0">
                              {t("DIGITALCARD.balanceCard")}
                            </p>
                            <CurrencyInput
                              className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
                              placeholder="Rp.10.000"
                              decimalsLimit={2}
                              prefix={"Rp "}
                              value={numberOnly(cardBalance)}
                              onValueChange={(value, name) => {
                                console.log(value);
                                setCardBalance(
                                  value != undefined ? Number(value) : 0
                                );
                              }}
                            />
                          </div>
                          <div className="mt-2">
                            <p className="m-0">
                              {t("DIGITALCARD.limitAccumulate")}
                            </p>
                            <CurrencyInput
                              className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
                              placeholder="Rp.10.000"
                              decimalsLimit={2}
                              prefix={"Rp "}
                              value={numberOnly(limitMax)}
                              onValueChange={(value, name) => {
                                console.log(value);
                                setLimitMax(
                                  value != undefined ? Number(value) : 0
                                );
                              }}
                            />
                          </div>
                          <div className="mt-2">
                            <p className="m-0">{t("DIGITALCARD.dailyLimit")}</p>
                            <CurrencyInput
                              className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
                              placeholder="Rp.10.000"
                              decimalsLimit={2}
                              prefix={"Rp "}
                              value={numberOnly(daily)}
                              onValueChange={(value, name) => {
                                console.log(value);
                                setDaily(
                                  value != undefined ? Number(value) : 0
                                );
                              }}
                            />
                          </div>
                          <div className="mt-2 flex flex-row justify-between">
                            <p className="m-0">
                              {t("DIGITALCARD.transUnlimited")}
                            </p>
                            <Switch
                              checked={isUnlimited}
                              onChange={setIsUnlimited}
                              className={`${isUnlimited ? "bg-psp-btn-primary" : "bg-silver"
                                } relative inline-flex items-center h-6 rounded-full w-10 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                            >
                              {/* <span
                        className={`${
                          isUnlimited ? "left-0" : "right-0"
                        } inline-block  transform bg-white rounded-full transition-transform`}
                      >
                      </span> */}
                              <span
                                aria-hidden="true"
                                className={`${isUnlimited
                                    ? "translate-x-5"
                                    : "translate-x-0"
                                  }
            pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                              />
                            </Switch>
                          </div>

                          <div className="mt-4 flex flex-row justify-evenly">
                            <button
                              type="button"
                              className="w-full h-10 mr-1 rounded-md text-white bg-psp-btn-red"
                              onClick={closeModal}
                            >
                              {t("DIGITALCARD.cancel")}
                            </button>
                            <button
                              type="button"
                              style={{
                                backgroundColor: customApp.app_accent_color,
                              }}
                              className={`w-full h-10 ml-1 rounded-md ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
                              onClick={saveData}
                            >
                              {t("DIGITALCARD.save")}
                            </button>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </Dialog>
              </Transition>
            </div>
            <div className=" my-3">
                <div className="text-lg font-semibold pb-3">
                  Menu Kartu
                </div>
                <div className="grid grid-cols-2">
                  <button hidden={
                      companyStorage.cardSetting.limitChange ? false : true
                    } className=" m-1 bg-white rounded-md p-2 flex" onClick={openModal}>
                    <div className=" w-8 h-8 flex justify-center items-center mr-2 rounded-md">
                      <img src={settingIcon} alt="" className={` w-5 h-5`} />
                    </div>
                    <div className=" flex items-center h-8 font-medium text-sm">
                      {t("DIGITALCARD.setLimit")}
                    </div>
                  </button>
                  <button className=" m-1 bg-white rounded-md p-2 flex" onClick={goToSync}>
                    <div className=" w-8 h-8 flex justify-center items-center mr-2 rounded-md">
                      <img src={syncHistory} alt="" className={` w-5 h-5`} />
                    </div>
                    <div className=" flex items-center h-8 font-medium text-sm">
                      {t("DIGITALCARD.syncHistory")}
                    </div>
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardWeb;
